import { generateEventId } from "./id.js";
import { hashEvent } from "./hash.js";
export function createEvent(input) {
    const clock = input.clock ?? Date.now;
    const idGen = input.idGen ?? generateEventId;
    const id = idGen();
    const createdAt = new Date(clock()).toISOString();
    const envelopeWithoutHash = {
        id,
        projectId: input.projectId,
        type: input.type,
        version: input.version,
        category: input.category,
        payload: input.payload,
        prevHash: input.prevHash,
        createdAt,
        createdBy: input.createdBy,
    };
    const hash = hashEvent(envelopeWithoutHash);
    return Object.freeze({ ...envelopeWithoutHash, hash });
}
//# sourceMappingURL=envelope.js.map